export default function getResource(label, vars = []) {
    const resources = {
        shade: `Teinte ${vars[0]}`,
        showFewerShades: 'Afficher moins de teintes',
        showMoreShades: `Afficher ${vars[0]} teintes supplémentaires`,
        previousSwatches: 'Échantillons précédents',
        nextSwatches: 'Échantillons suivants'
    };

    return resources[label];
}
